import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "hhn-commons";

type ButtonAddType = {
  isSelected: boolean;
  onClick: () => void;
};
const ButtonAdd = ({ isSelected, onClick }: ButtonAddType) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <Button
      disableRipple
      disableTouchRipple
      variant={isSelected ? "contained" : "outlined"}
      fullWidth={true}
      disableElevation={isSelected}
      data-testid="add-member-btn"
      onClick={onClick}
      style={{ textTransform: "none" }}
    >
      {tNs("referral.add")}
    </Button>
  );
};

export default ButtonAdd;
